export const RETURN_RECEIPT_STATUS = {
  NOT_NEEDED: 'Nije potrebna',
  WAITING: 'Čeka',
  RETURNED: 'Vraćena',
}

export const translateReturnReceiptStatus = (status, t) => {
  switch (status) {
    case RETURN_RECEIPT_STATUS.WAITING:
      return t('return_receipt_waiting')
    case RETURN_RECEIPT_STATUS.RETURNED:
      return t('return_receipt_returned')
    case RETURN_RECEIPT_STATUS.NOT_NEEDED:
      return t('return_receipt_not_needed')
    default:
      return status
  }
}

const toBool = (value) =>
  value === true || value === 'true' || value === 1 || value === '1'

export const isReturnReceiptEligible = (file) =>
  toBool(file?.issued) && !toBool(file?.received)

export const getReturnReceiptStatus = (file) => {
  if (!file) return RETURN_RECEIPT_STATUS.NOT_NEEDED
  if (toBool(file.received)) return RETURN_RECEIPT_STATUS.NOT_NEEDED
  if (!toBool(file.issued)) return RETURN_RECEIPT_STATUS.NOT_NEEDED
  if (!toBool(file.expectsReturnReceipt)) return RETURN_RECEIPT_STATUS.NOT_NEEDED
  if (!file.returnReceiptAttachmentId) return RETURN_RECEIPT_STATUS.WAITING
  return RETURN_RECEIPT_STATUS.RETURNED
}
